module.exports = __webpack_public_path__ + "static/bg-brownies-b47ed030896b917e4d163775cb8d1073.jpg";